import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import { LEAVE_MODAL_CONFIG } from '~/organizer/shared/components/shared/layouts/funnel/funnel.component';
import { NAVIGATION_ROUTING } from '~/organizer/shared/components/shared/navigation-buttons/navigation-buttons.component';
import { STEPPER_TAB_BAR_CONFIG } from '~/organizer/shared/components/shared/page-container/page-container.component';
import { OrganizerSharedModule } from '~/organizer/shared/shared.module';

import { OrganizerActivitySharingRoutingModule } from './activity-sharing-routing.module';
import { OrganizerActivitySharingPageShareComponent } from './components/pages/share/share.component';
import { OrganizerActivitySharingPageSuccessComponent } from './components/pages/success/success.component';
import { organizerActivitySharingRoutingConfig } from './configs/routing.config';

@NgModule({
  imports: [
    CommonModule,
    ComponentModule,
    CoreModule,
    TranslateModule,
    OrganizerSharedModule,
    OrganizerActivitySharingRoutingModule,
  ],
  providers: [
    {
      provide: LEAVE_MODAL_CONFIG,
      useValue: {},
    },
    {
      provide: NAVIGATION_ROUTING,
      useValue: organizerActivitySharingRoutingConfig,
    },
    {
      provide: STEPPER_TAB_BAR_CONFIG,
      useValue: [],
    },
  ],
  declarations: [
    OrganizerActivitySharingPageShareComponent,
    OrganizerActivitySharingPageSuccessComponent,
  ],
})
export class OrganizerActivitySharingModule {}
